import { Suspense, lazy } from "react";

const LazyGenericCreditCardIcon = lazy(
  () =>
    import(
      /* webpackChunkName: "genericCreditCard", webpackPrefetch: true */ "static/svg/creditCards/generic-card"
    )
);
const LazyAmericanExpressCard = lazy(
  () =>
    import(
      /* webpackChunkName: "americanExpress" */ "static/svg/creditCards/american-express-card"
    )
);
const LazyMasterCard = lazy(
  () =>
    import(
      /* webpackChunkName: "mastercard" */ "static/svg/creditCards/master-card"
    )
);
const LazyVisaCard = lazy(
  () =>
    import(/* webpackChunkName: "visa" */ "static/svg/creditCards/visa-card")
);

interface CardBrandProps {
  brand: string;
}

const renderBrand = (brand: string) => {
  switch (brand) {
    case "visa":
      return <LazyVisaCard width={24} />;
    case "mastercard":
      return <LazyMasterCard width={24} />;
    case "american-express":
      return <LazyAmericanExpressCard width={24} />;
    default:
      return <LazyGenericCreditCardIcon width={24} />;
  }
};

export const CardBrand = ({ brand }: CardBrandProps) => {
  return <Suspense fallback={<></>}>{renderBrand(brand)}</Suspense>;
};
